import type React from 'react'
import { useSelector } from 'react-redux'

import { selectIsLoading } from '@/store'
import { clsJoin } from '@/utils'
import {
  BraintreeButtons,
  PaymentsList,
  PlanCard,
  SubscriptionLinks,
  SubscriptionSkeleton,
  SubscriptionStats,
} from './components'
import { useSubscription } from './hooks'
import css from './styles.module.css'

export const Subscription: React.FC = () => {
  const { data, onCancel, onSwitch, onDownload, onUpdate } = useSubscription()
  const { canceled, payments, stats, plan, braintree, messages, links } = data

  const loading = useSelector(
    selectIsLoading('braintree_cancel', 'subscription_fetch')
  )

  if (loading) {
    return <SubscriptionSkeleton />
  }

  return (
    <div className={clsJoin(css.responsive, css.content)}>
      <h1 className={css.header}>Subscription</h1>
      <PlanCard
        canceled={canceled}
        planId={plan}
        onSwitch={onSwitch}
        messages={messages}
      >
        {braintree ? (
          <BraintreeButtons
            canceled={canceled}
            onCancel={onCancel}
            onUpdate={onUpdate}
          />
        ) : (
          <SubscriptionLinks links={links} />
        )}
      </PlanCard>
      <SubscriptionStats stats={stats} />
      <PaymentsList onDownload={onDownload} items={payments} />
    </div>
  )
}
